import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { Link, useNavigate } from 'react-router-dom';
import { USER_LOGIN } from '../apollo/user/userMutation';
import { toast } from 'react-toastify'; //? React-Toastify
import { useAuth } from '../context/UserAuth';

function Login() {
  const navigate = useNavigate();
  const { LogIn } = useAuth();

  const [login, setLogin] = useState({
    email: '',
    password: '',
  });

  const handleChangeLogin = (e) => {
    setLogin((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  /**
   * ! USER_LOGIN : Apollo-Graphql Implementation
   */
  const [UserLogin] = useMutation(USER_LOGIN, {
    onError: (error) => {
      toast.error(error?.message);
    },
    onCompleted: ({ userLogin }) => {
      if (userLogin?.status === 200) {
        toast.success(userLogin?.message);
        //! storing in Redux
        LogIn(userLogin?.payload, userLogin?.token);

        navigate('/');
      }
    },
  });

  const handleSubmitLogin = (e) => {
    e.preventDefault();

    if (!login.email || !login.password) return;

    UserLogin({
      variables: {
        email: login?.email,
        password: login?.password,
      },
    });
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className='login container'>
      <section className='vh-100'>
        <div className='container py-5 h-100'>
          <div className='row d-flex align-items-center justify-content-center h-100'>
            <div className='col-md-8 col-lg-7 col-xl-6'>
              <img
                src='https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-login-form/draw2.svg'
                className='img-fluid'
                alt='Phone_image'
              />
            </div>
            <div className='col-md-7 col-lg-5 col-xl-5 offset-xl-1'>
              <form>
                <div className='form-outline mb-4'>
                  <label className='form-label' htmlFor='form1Example13'>
                    <strong>Email address</strong>
                  </label>
                  <input
                    type='email'
                    placeholder='email'
                    id='form1Example13'
                    autoComplete='true'
                    className='form-control form-control-lg'
                    required
                    value={login?.email}
                    name='email'
                    onChange={handleChangeLogin}
                    style={{ border: '1px solid black' }}
                  />
                </div>

                <div className='form-outline mb-4'>
                  <label className='form-label' htmlFor='form1Example23'>
                    <strong>Password</strong>
                  </label>
                  <input
                    type='password'
                    placeholder='password'
                    id='form1Example23'
                    autoComplete='true'
                    className='form-control form-control-lg'
                    required
                    value={login?.password}
                    name='password'
                    onChange={handleChangeLogin}
                    style={{ border: '1px solid black' }}
                  />
                </div>

                <div className='d-flex justify-content-around align-items-center mb-4'>
                  if You Don't Have an account ?<Link to='/signup'>Register</Link>
                </div>

                <button type='submit' className='btn btn-primary btn-lg btn-block' onClick={handleSubmitLogin}>
                  Login
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Login;
